import { useState } from "react";

export const useToken = () => {
  // eslint-disable-next-line react/hook-use-state
  const [token, setTokenInternal] = useState(sessionStorage.getItem("token"));

  const setToken = (newToken) => {
    sessionStorage.setItem("token", newToken);
    setTokenInternal(newToken);
  };

  return [token, setToken];
};
